'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'image-polaroid';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f8c4';
var svgPathData = 'M448 32l-448 0 0 448 448 0 0-448zM384 96l0 256-320 0 0-256 320 0zM160 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM352 272l-128-112-128 112 0 48 256 0 0-48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faImagePolaroid = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;